import React, { useEffect, useState } from "react";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import HomeService from "Services/http/endpoints/home/HomeService";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import CountStatics from "./CountStatics/CountStatics";
import HomePageStatisticsIndex from "./Statistics";
import OnFirstButtonsIndex from "./OnFirstButtons";
import { useDispatch, useSelector } from "react-redux";
import { isSuperAdmin } from "Helpers/analyzeToken";

function HomePage() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [dataCount, setDataCount] = useState(null);
  const { transfer } = useSelector((state) => ({
    transfer: state.auth.transfer,
  }));

  useEffect(() => {
    if (!isSuperAdmin() || transfer) {
      (async () => {
        try {
          setLoading(true);
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
          };
          const response = await HomeService.getCount(params);
          let err = StatusHandler(response);
          if (!err.isFail) {
            setDataCount(response.data.Value);
          }
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      })();
    }
  }, [transfer]);

  return (
    <div className="my-3">
      <BackDropLoading loading={loading} />
      {dataCount && (
        <>
          <CountStatics data={dataCount} />
          <OnFirstButtonsIndex externalData={dataCount} />
          <HomePageStatisticsIndex externalData={dataCount} />
        </>
      )}
    </div>
  );
}

export default HomePage;
